// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd39743d","239":"dbf51872","455":"4ba934e0"}[chunkId] + ".chunk.js";
};